// Utilities
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";

// Constants
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { teamMemberService } from "../../../../../Api/Services/TeamMembers";
import { IBaseResponse } from "../../../../../Types/UserProfileDetails";
import { IApprovedLeaveFormData } from "../../types";

/**
 * Async thunk to handle approved leave.
 * Dispatches an API call to the leave service.
 */
export const teamMembersLeaveApprovedRequestThunk = createServiceAsyncThunk<
  IBaseResponse, // Response type data from the leave approval API
  IApprovedLeaveFormData // The data required for leave approval (leave ID, action type, and optional comment)
>(
  ACTION_NAMES.UPDATE_APPROVE_LEAVE, // Name of the action
  (leaveApproveData) => teamMemberService.approveLeave(leaveApproveData), // API call
  ERROR_MESSAGES.APPROVE_LEAVE_UPDATE_FAILURE // Error Message
);

/**
 * Slice to manage the state for approved leave.
 * Includes actions to clear errors and handle async states.
 */
const teamMembersLeaveApprovedRequestSlice = createGenericSlice<
  IBaseResponse,
  IApprovedLeaveFormData
>(
  SLICE_NAMES.APPROVED_LEAVE, // Slice Name
  teamMembersLeaveApprovedRequestThunk // Async Thunk
);

// Export the actions for resetting error and leave information
export const {
  clearError: clearTeamMembersLeaveApprovedError,
  clearSuccessMessage: clearTeamMembersLeaveApprovedSuccessMessage,
} = teamMembersLeaveApprovedRequestSlice.actions;

// Export the reducer for integration in the Redux store
export default teamMembersLeaveApprovedRequestSlice.reducer;
